import { api, config, rest } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

const changePasswordRequest = ({ oldPassword, newPassword }) => {
  return api.post(
    generatePath(rest.CHANGE_PASS),
    {
      old_password: oldPassword,
      new_password: newPassword
    },
    config('json')
  );
};

export { changePasswordRequest };
